import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Button } from "pepsico-ds";
import { useEffect } from "react";
import ToastNotification from "../../components/common/toastNotification/ToastNotification";
import JsonFormsWrapper from "../../components/jsonForms/jsonFormsWrapper/JsonFormsWrapper";
import { updateFieldProperties } from "../../components/leaderboards/utils/createLeaderboard";
import { useCreateLeaderboard } from "../../hooks/createLeaderboardHook";
import "./LeaderboardsPage.scss";
import {
  addKeyValueToElement,
  createLeaderboardsJsonSchema,
  createLeaderboardsUISchema,
} from "./schemas";

function CreateLeaderboardsModal({
  showModal,
  toggleCreateLeaderboardModal,
  refetch,
  selectedLeaderboard,
  setSelectedLeaderboard,
  createShowToast = true,
}) {
  // Use the custom hook for leaderboard creation logic
  const {
    createLeaderboardData,
    setCreateLeaderboardData,
    toast,
    loading,
    handleCreateLeaderboard,
    handleCloseModal,
    goToCampaigns,
    closeToast,
  } = useCreateLeaderboard({
    showModal,
    toggleCreateLeaderboardModal,
    refetch,
    selectedLeaderboard,
    setSelectedLeaderboard,
    createShowToast,
    jsonSchema: createLeaderboardsJsonSchema,
  });

  // Update field properties when modal opens or selected leaderboard changes
  useEffect(() => {
    if (showModal) {
      // Update field properties based on leaderboard state
      updateFieldProperties(selectedLeaderboard, addKeyValueToElement);
    }
  }, [selectedLeaderboard, showModal]);

  // All the validation and handling logic has been moved to the hook

  return (
    <>
      <Dialog className="create-leaderboards-modal" open={showModal} scroll="paper">
        <DialogTitle>
          <Grid container justifyContent="space-between" direction="row">
            <Grid item xs={10}>
              <h2 style={{ marginLeft: "18%", textAlign: "center" }}>
                {selectedLeaderboard?.id
                  ? "Update Leaderboard"
                  : "Create New Leaderboard"}
              </h2>
            </Grid>
            <Grid item xs={1} display="flex" justifyContent="flex-end">
              <CloseIcon onClick={handleCloseModal} className="cursor-pointer" />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent sx={{ overflowX: "hidden" }}>
          <div className="my-5">
            <JsonFormsWrapper
              jsonschema={createLeaderboardsJsonSchema}
              uischema={createLeaderboardsUISchema}
              data={createLeaderboardData}
              onChange={(val) => {
                if (val && Object.keys(val).length > 7) {
                  setCreateLeaderboardData(val);
                }
              }}
            />
          </div>
          <div className="mt-5 display-flex justify-content-end justify-content-space-between">
            <Button onClick={handleCloseModal} variant="secondary">
              Cancel
            </Button>
            <Button
              isLoading={loading}
              variant="primary"
              className="justify-content-space-around"
              onClick={() => {
                handleCreateLeaderboard();
              }}
              iconTrailing="arrow_forward"
              disabled={loading}
            >
              {selectedLeaderboard?.id ? "Update" : "Create"}
            </Button>
          </div>
        </DialogContent>
        {!createShowToast && (
          <ToastNotification
            {...toast}
            handleClose={closeToast}
            primaryActionLabel={"Close"}
            sx={{ zIndex: 9999 }}
          />
        )}
      </Dialog>
      {createShowToast && (
        <ToastNotification
          {...toast}
          handleClose={
            toast.type === "success" && toast.description
              ? goToCampaigns
              : closeToast
          }
          primaryActionLabel={
            toast.type === "success" && toast.description
              ? "Go to Campaigns"
              : "Close"
          }
          sx={{ zIndex: 9999 }}
        />
      )}
    </>
  );
}

export default CreateLeaderboardsModal;
